export const GET_TICKET_REQUESTED = 'GET_TICKET_REQUESTED';
export const GET_TICKET_SUCCESS = 'GET_TICKET_SUCCESS';
export const GET_TICKET_FAILED = 'GET_TICKET_FAILED';

export const WAIVE_TICKET_REQUESTED = 'WAIVE_TICKET_REQUESTED';
export const WAIVE_TICKET_SUCCESS = 'WAIVE_TICKET_SUCCESS';
export const WAIVE_TICKET_FAILED = 'WAIVE_TICKET_FAILED';
